import { render } from "./CustomerLicensing.vue?vue&type=template&id=6446b7ba"
import script from "./CustomerLicensing.vue?vue&type=script&lang=js"
export * from "./CustomerLicensing.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__